export const PageNumber = (Splide, Components, options) => {
    const { root } = Components.Elements;

    const defaults = {
        separator: " | ",
        prepend: "",
        pad: 1,
    };

    let el,
        controls,
        settings = defaults;

    if (typeof options.pageNumber === "object") {
        settings.separator = options.pageNumber.separator ?? defaults.separator;
        settings.prepend = options.pageNumber.prepend ?? defaults.prepend;
        settings.pad = options.pageNumber.pad ?? defaults.pad;
    }

    function pageNum(index) {
        if (!index || !options.perPage) {
            return 1;
        }

        return Math.ceil((index + 1) / options.perPage);
    }

    function mount() {
        controls = root.querySelector(".splide__controls");

        if (!controls || !options.pageNumber) return;

        el = controls.querySelector(".splide__page-number");

        if (!el) {
            el = document.createElement("div");
            el.classList.add("splide__page-number");
            controls.appendChild(el);
        }

        update();

        Splide.on("move resized", update);
    }

    function formatPageNum(pageNum) {
        if (window.innerWidth >= 1024) {
            return `${pageNum}`.padStart(settings.pad, "0");
        }

        return pageNum;
    }

    function update() {
        if (!el) return;

        if (pageNum(Splide.length - 1) > 0) {
            el.innerHTML = `
                <span class="splide__page-number__prepend">${settings.prepend}</span>
                <span class="splide__page-number__from">${formatPageNum(pageNum(Splide.index))}</span>
                <span class="splide__page-number__separator">${settings.separator}</span>
                <span class="splide__page-number__to">${formatPageNum(pageNum(Splide.length - 1))}</span>
            `;
        } else {
            el.innerHTML = ``;
        }
    }

    return {
        mount,
    };
};
